// extracted by mini-css-extract-plugin
module.exports = {"BannerContainer":"_2EjAr"};